import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private storageService: StorageService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const requiredRoles = next.data['roles'] as string[];
    const user = this.storageService.getUser();

    if (user && requiredRoles.some(role => user.hasRole(role))) {
      return true;
    }

    console.error('User has no roles assigned or is not authorized.');
    return this.router.createUrlTree(['/authentication/logout']);
  }
}